// Module
var code = "<accessibility-skip-links options=\"$ctrl.skipLinkOptions\"></accessibility-skip-links><ngx-super-bar ng-cloak ng-if=\"currentUser.is_root_user\"></ngx-super-bar><div class=\"vertical-nav\"><dashboard><ui-view-inner></ui-view-inner></dashboard><ngx-pwa-install-prompt></ngx-pwa-install-prompt></div>";
// Exports
module.exports = code;